import PropTypes from 'prop-types'

// An option row of the select primitive reaches the DOM carrying nothing but its own copy: the
// primitive puts the visible label into the row's accessible name and keeps the option's value in
// its own state, so the only way to address one option is to name the words printed on it. That
// makes a reworded label break the address rather than an assertion, and it makes the wrong option
// selectable in silence once a set is reordered. Wrapping the label puts the value back on the row.
const OptionLabel = ({ name, value, html, children }) => {
  const props = {
    'data-testid': `stat-option-${name}-${value}`,
    'data-option-value': String(value)
  }

  return html ? <span {...props} dangerouslySetInnerHTML={{ __html: html }} /> : <span {...props}>{children}</span>
}

OptionLabel.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  html: PropTypes.string,
  children: PropTypes.node
}

OptionLabel.displayName = 'OptionLabel'

// The plain-text case, which is most of them: `optionRow('md-view-mode')` is the whole wiring a
// select needs. A select whose labels carry markup passes `html` to the component instead.
export const optionRow =
  (name, field = 'value') =>
  option => (
    <OptionLabel name={name} value={option[field]}>
      {option.text}
    </OptionLabel>
  )

export default OptionLabel
